<template>
    <div class="body-panel">
        <template v-if="folder != null">
            <div class="body-panel-control separator">
                <div class="control-block-left">
                    <div class="flex">
                        <p class="btn-back margin-right-10">
                            <a class="router-link-active" href="" @click.prevent="back">Назад</a>
                        </p>
                        <p class="caption-help margin-right-10" v-if="folder.new">Добавление папки</p>
                        <p class="caption-help" v-if="!folder.new">Редактирование папки #{{ folder.Name }}</p>
                    </div>
                </div>
                <div class="control-block-right">
                    <div class="btns flex">
                        <button type="button" class="btn btn-primary" @click="saveFolder()" :disabled="savingInProgress">Сохранить</button>
                        <button type="button" class="btn btn-delete" @click="deleteFolder">Удалить</button>
                    </div>
                </div>
            </div>
            <div class="body-panel-content body-panel-content-page">
                <div class="body-panel">
                    <domain-folder :folder="folder" :folderPath="'/uploads/domain-folders/'" @update="onUpdate"></domain-folder>
                </div>
            </div>

        </template>

        <vue-headful title="Папки sku" />
    </div>
</template>

<script>
    import BackendApi from '../../backendApi'
    import UI from '../../helpers/ui-helpers'

    let backendApi = new BackendApi();

    let ImageStyleDefault = {
        top: 0,
        left: 100,
        translateY: 0,
        translateX: -50,
        size: 100,
        resizeType: 1
    };

    export default {
        name: "sku-folder-edit",

        data() {
            return {
                folder: null,
                imgSite: {},
                imgMobile: {},
                savingInProgress: false
            }
        },

        methods: {

            back() {
                this.$router.back();
            },

            loadFolder() {
                let vm = this;
                let id = parseInt(vm.$route.params.id);
                if (id === 0) {
                    let parentId = vm.$route.query.folderId;

                    this.folder = {
                        new: true,
                        ImageStyle: JSON.parse(JSON.stringify(ImageStyleDefault)),
                        ParentId: parentId,
                        DeleteImage: false,
                        FileData: null,
                        ImageStyleMobile: JSON.parse(JSON.stringify(ImageStyleDefault)),
                        ImageMobile: {}
                    };

                    return new Promise(resolve => resolve());
                }
                else {
                    return backendApi.domainFolderLoad(id).then(function (response) {
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при загрузке папки');
                        }
                        else {
                            if (response.data == null) {
                                vm.$router.back();
                            }

                            if (response.data.ImageStyle) {
                                response.data.ImageStyle = JSON.parse(response.data.ImageStyle);
                            } else {
                                response.data.ImageStyle = JSON.parse(JSON.stringify(ImageStyleDefault));
                            }
                            if (response.data.ImageStyleMobile) {
                                response.data.ImageStyleMobile = JSON.parse(response.data.ImageStyleMobile);
                            } else {
                                response.data.ImageStyleMobile = JSON.parse(JSON.stringify(ImageStyleDefault));
                            }

                            vm.folder = Object.assign({}, response.data, { DeleteImage: false, FileData: null });
                            vm.folder.ImageMobile = {};
                        }
                    })
                }
            },

            saveFolder() {
                let vm = this;

                this.$validator.validate().then(result => {
                    if (!result) {
                        UI.toastr.error('Проверьте введённые данные');
                    }
                    else {
                        if (vm.savingInProgress) {
                            return;
                        }
                        vm.savingInProgress = true;
                        UI.blockUI('.portlet', 'Сохранение...');

                        let selectedProjectId = localStorage.getItem('selectedProjectId');

                        let saveObj = Object.assign({}, vm.folder, {
                            ProjectId: selectedProjectId != null ? parseInt(selectedProjectId) : null,
                            DeleteImage: vm.imgSite.Image.Id === -1,
                            DomainType: 2
                        });
                        saveObj.ImageStyle = JSON.stringify(vm.imgSite.ImageStyle);
                        saveObj.FileData = vm.imgSite.Image.FileData;
                        saveObj.FileName = vm.imgSite.Image.FileName;
                        saveObj.ImageMobile = vm.imgMobile.Image;
                        if (vm.imgMobile.ImageStyle.useMainPhoto) {
                            saveObj.ImageMobile.FileName = '';
                            saveObj.ImageMobile.FileData = '';
                            saveObj.ImageMobile.Id = -1;
                            saveObj.ImageMobilePath = '';
                        }
                        saveObj.ImageStyleMobile = JSON.stringify(vm.imgMobile.ImageStyle);

                        backendApi.domainFolderSave(saveObj).then(function (response) {
                            //console.info('response.data', response.data)
                            UI.unblockUI('.portlet');
                            if (response.hasError) {
                                UI.toastr.error('Ошибка при сохранении папки');
                            } else {
                                UI.toastr.success('Успешно сохранено');

                                vm.$router.back();
                            }
                            vm.savingInProgress = false;
                        });
                    }
                });
            },

            deleteFolder(){
                let vm = this;

                if (confirm('Вы уверены? Подпапки будут также удалены.')) {
                    UI.blockUI('.portlet', 'Удаление...');
                    backendApi.domainFolderDelete(vm.folder.Id).then(function (response) {
                        UI.unblockUI('.portlet');
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при удалении папки');
                        } else {
                            UI.toastr.success('Успешно удалено');

                            vm.$router.back();
                            //that.$router.push('/sku');
                        }
                    });
                }
            },

            onUpdate(imageSite, imageMobile) {
                this.imgSite = imageSite;
                this.imgMobile = imageMobile;
            }
        },


        mounted() {
            let vm = this;
            UI.blockUI('.page-content', 'Загрузка...');
            vm.loadFolder().then(() => {
                UI.unblockUI('.page-content');
            });
        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// Content/src/views/edit/RewardFolderEdit.vue